import "./App.css";
import One from "./milestones/one";
import FirstScreen from "./components/firstScreen/firstScreen";
import Home from "./pages/home";

// import React, { useEffect, useState, useRef } from "react";
// import * as ScrollMagic from "scrollmagic";
// import {
//   ScrollMagicPluginIndicator,
//   ScrollMagicPluginGsap,
// } from "scrollmagic-plugins";
// import { TweenMax, TimelineMax } from "gsap";


// ScrollMagicPluginIndicator(ScrollMagic);
// ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
// const controller = new ScrollMagic.Controller();

import "./style.scss"

function App() {
  return <>
   
    <div className="wrapper">
      <Home/>
    </div>
  </>;
}

export default App;
